/** Token-based badge — mirrors the prototype's `.badge.b-*` classes so screens never hardcode a hex. */

import type { ReactNode } from 'react'
import type { BadgeTone } from '../lib/format'

const TONE_CLASS: Record<BadgeTone, string> = {
  ok: 'b-ok',
  warn: 'b-warn',
  info: 'b-info',
  danger: 'b-dan',
  violet: 'b-vio',
  muted: 'b-mut',
  teal: 'b-teal',
}

export function Badge({
  tone = 'info',
  children,
  className,
  title,
}: {
  tone?: BadgeTone
  children: ReactNode
  className?: string
  title?: string
}) {
  return (
    <span className={`badge ${TONE_CLASS[tone]}${className ? ` ${className}` : ''}`} title={title}>
      {children}
    </span>
  )
}
